<!-- Файлы и чеки расхода. -->
<template>
  <BaseFormSection title="Файлы" icon="download">
    <BaseFormField wide>
      <AttachmentUploader
        :attachment-ids="attachmentIds"
        requisite-code="expense"
        :form-id="formId"
        :existing-attachments="existingAttachments"
        @update:attachment-ids="$emit('update:attachmentIds', $event)"
      />
    </BaseFormField>
  </BaseFormSection>
</template>

<script>
import AttachmentUploader from "@/components/Attachment/Uploader.vue";

export default {
  name: "ExpenseFilesSection",

  components: {
    AttachmentUploader,
  },

  props: {
    formId: { type: String, required: true },
    existingAttachments: { type: Array, required: true },
    attachmentIds: { type: Array, default: undefined },
  },

  emits: ["update:attachmentIds"],
};
</script>
